import React, { Component } from 'react'
import { connect } from 'react-redux'
import cx from 'classnames'

import { openNav } from '../../../actions'

import './nav-button.scss'

class NavButton extends Component {

  onClick = e => {
    if (this.props.navOpen === false) {
        this.props.dispatch(openNav(true))
    } else {
        this.props.dispatch(openNav(false))
    }
  }

  render () {
    const className = cx(
        'header-mobile-btn',
        { 'is-open': this.props.navOpen }
    )

    return (
        <button 
            className={className}
            onClick={this.onClick}>
            <span className="nav-bar"></span>
            <span className="nav-bar"></span>
            <span className="nav-bar"></span>
        </button>
    )
  }

}

export default connect(state => ({
    navOpen: state.uiReducer.isNavOpen
}))(NavButton)


// WEBPACK FOOTER //
// ./src/components/shared/nav-button/index.jsx